// ====================== 基础
// import Taro from '@tarojs/taro'

import { observable, makeAutoObservable, action, runInAction, toJS } from 'mobx'
import { createContext } from 'react'

import logger from '@/utils/logger'

import alertDialog from '../components/DialogBox'
import { SCHEDULE_PERIOD_TYPE } from '../enum'
import { scheduleSettingMobile } from '../service'
/**
 *  全局状态
 */

export class SechduleStore {
  constructor() {
    makeAutoObservable(this)
  }
  @observable virtualList: any[] = [] // 虚拟列表数据源
  @observable originList: any[] = [] // 原始数据源
  @observable isPublish: boolean = true // 是否发布
  @observable revocable: boolean = false // 是否可撤回的
  @observable unPublish: number = 0 // 未发布
  @observable pickerTypeDate: any = [] // 周期时间
  @observable dateType: any = 'date' // 配置周期类型
  @observable schedulePeriodType: any = SCHEDULE_PERIOD_TYPE.WEEK // 配置周期类型
  @observable setting: any = {}
  @observable valueName: any = ''
  @observable isCoverMode: any = false // 覆盖模式
  @observable isDeleteMode: any = false // 橡皮擦
  @observable isClear: any = false // 清空班表
  @observable isIntroduce: any = false // 引入班表
  @observable isClearClass: any = false // 删除班表
  @observable copyOrClearLoading: any = false // 清空班表/ 引入班表 loading
  @observable scheduleFailures: any[] = [] // 删除班表报错数据
  @observable extraOpen: boolean = false
  @observable extraContent: string = ''
  @observable queryLoading: boolean = false
  @observable scheduleQueryParams: any = {} // 排班查询参数
  // set虚拟列表数据源
  @action setVirtualList(list: any[], origin: any[]) {
    this.virtualList = list
    this.originList = origin
  }
  // set完整虚拟列表数据源
  @action setOriginList(origin: any[]) {
    this.originList = origin
  }
  // set单个虚拟列表数据源
  @action setVirtual({ employee_id, data, originData }: any) {
    const row = this.originList?.findIndex((item: any) => item?.employee_id === employee_id)
    const col = this.originList?.[row]?.plan_results?.findIndex(
      (item: any) => item?.schedule_date === originData?.schedule_date
    )
    console.log('本地setVirtual::::::', row, col, originData)
    this.virtualList = this.virtualList?.map((item: any, index: number) => {
      return {
        ...item,
        children: item?.children?.map((_item: any, _index: number) => {
          if (index === row && _index === col) {
            console.log('picker::::::', row, col)
            return data
          }
          return _item
        })
      }
    })
    const orignList = this.originList?.map((item: any, index: number) => {
      return {
        ...item,
        plan_results: item?.plan_results?.map((_item: any, _index: number) => {
          if (index === row && _index === col) {
            console.log('本地picker::::::', row, col, originData)
            return originData
          }
          return _item
        })
      }
    })
    this.originList = orignList
    console.log('this.virtualList:::', toJS(this.virtualList))
    return orignList
  }
  // set单个虚拟列表的行数据
  @action setVirtualRow({ row, data }: any) {
    this.virtualList = this.virtualList?.map((item: any, index: number) => {
      if (index === row) {
        return {
          ...item,
          ...data
        }
      }
      return item
    })
    this.originList = this.originList?.map((item: any, index: number) => {
      if (index === row) {
        return {
          ...item,
          ...data
        }
      }
      return item
    })
    console.log('this.virtualList:::', toJS(this.virtualList))
  }
  @action setQueryLoading(bool: boolean) {
    this.queryLoading = bool
  }
  @action
  setIsPublish = (bool: boolean, uncount = 0) => {
    this.isPublish = bool
    this.unPublish = Math.max(uncount, 0)
  }
  @action setScheduleQueryParams(v: any) {
    this.scheduleQueryParams = {
      ...this.scheduleQueryParams,
      ...v
    }
  }
  // 配置周期类型
  @action getDateType(v: any) {
    this.dateType = v
  }
  // 配置排班周期类型
  @action setSchedulePeriodType(v: any) {
    this.schedulePeriodType = v
  }
  // 删除班表报错数据
  getFailuresData(data: any, title?: string) {
    alertDialog({ data, title })
  }
  // 配置周期时间
  @action getPickerTypeDate(v: any) {
    this.pickerTypeDate = v
  }
  // 搜索信息
  @action getValueName(v: any) {
    this.valueName = v
  }
  // 搜索信息
  @action getCopyOrClearLoading(bool: boolean) {
    this.copyOrClearLoading = bool
  }
  // 删除班表
  @action getClearClass(bool: boolean) {
    this.isClearClass = bool
  }
  // 清空班表/ 引入班表 loading
  @action getClearShow(bool: boolean) {
    this.isClear = bool
  }
  // 清空班表/ 引入班表 loading
  @action getIntroduceShow(v: boolean) {
    this.isIntroduce = v
  }
  // 配置信息
  @action
  async runScheduleSetting() {
    try {
      const { data } = await scheduleSettingMobile()
      // await 之后，再次修改状态需要动作:
      runInAction(() => {
        this.setting = data || {}
        this.isCoverMode = data?.schedule_overwrite_append_button_default === 2
      })
    } catch (error) {
      logger(error)
    }
  }
  // 删除模式
  @action setDeleteMode(v: boolean) {
    this.isDeleteMode = v
  }
  @action setExtraOpen(v: boolean, content: string) {
    this.extraOpen = v
    this.extraContent = content
  }
  @action clearData = () => {
    this.resetData()
  }
  /**
   * 设置是否可撤回的
   * @param v
   */
  @action setRevocable(v: boolean) {
    this.revocable = v
  }
  // 重置初始化
  @action
  resetData(isExit?: boolean) {
    this.virtualList = []
    this.dateType = 'date'
    this.schedulePeriodType = SCHEDULE_PERIOD_TYPE.WEEK
    isExit && (this.pickerTypeDate = [])
    this.isDeleteMode = false
    this.setting = {}
    this.valueName = ''
    this.isClear = false
    this.isIntroduce = false
    this.copyOrClearLoading = false
    this.isClearClass = false
    this.scheduleFailures = []
  }
}
const scheduleStoreNoContext = new SechduleStore()
export const scheduleStoreWithContext = createContext(scheduleStoreNoContext)
export default scheduleStoreNoContext
